import type { ReactElement } from 'react';
import './Switch.css';

/**
 * The one on/off switch (2026-09-12 拍板): every setting in Ember — the
 * account-wide ones in Settings and the per-Ember ones on the owner's page —
 * is this control, flipped in place. role="switch" + aria-checked carry the
 * state and the knob's position restates it; color is never the only signal.
 * `pending` is the stretch where the switch waits on something outside the
 * page (Settings' text-message consent) — neither state yet.
 * `data-log-state` is the state the tap PRODUCES: an on switch is being
 * turned off.
 */
export function Switch({ on, label, busy = false, pending = false, unavailable = false, log, logAttrs, onFlip }: {
  on: boolean;
  /** The accessible name — the row's title. */
  label: string;
  /** A write in flight: no taps, same colours (never greyed). */
  busy?: boolean;
  pending?: boolean;
  /** The setting cannot be turned on here (its own look, the third of three; frontend-ui-standard Switch contract). */
  unavailable?: boolean;
  /** `ui.clicked` name, from the registry vocabulary. */
  log: string;
  logAttrs?: Record<string, string | undefined>;
  onFlip: () => void;
}): ReactElement {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      className={`ember-switch${on ? ' is-on' : ''}${pending ? ' is-pending' : ''}${unavailable ? ' is-unavailable' : ''}`}
      disabled={busy || unavailable}
      data-log={log}
      data-log-state={on ? 'off' : 'on'}
      {...logAttrs}
      onClick={onFlip}
    >
      <span className="ember-switch-knob" aria-hidden />
    </button>
  );
}
